import { Button } from "antd";
import { FlexDiv, HorizontalFlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const HeaderContainer = styled(FlexDiv)`
    padding-top: 8px;
`
export const TicketHeader = styled(HorizontalFlexDiv)`
    height: 50px;
    justify-content: end;
    align-items: center;
    padding-right: 8px;
`
export const TicketDetailContainer = styled(FlexDiv)`
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 8px;
    gap: 14px;
    flex: 1;
    overflow: auto !important;
`
export const FooterContainer = styled(FlexDiv)`
    height: 110px;
    align-items: end;
`
export const FooterTotalContainer = styled(HorizontalFlexDiv)`
    height: 40px;
    gap: 8px;
    justify-content: end;
    align-items: center;
    padding-right: 8px;
`
export const TotalLabel = styled.label`
    font-weight: bold;
    font-size: 16px;
`
export const FooterActionContainer = styled(FlexDiv)`
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 8px 8px 8px 8px;
    width: 100%;
`
export const ActionButton = styled(Button)`
    width: 100%;
    height: 40px;
    font-size: 18px;
`
export const CategoriesContainer = styled(HorizontalFlexDiv)`
    background-color: white;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    border-radius: 8px;
    height: 47px;
    align-items: center;
    justify-content: space-between;
    padding-left: 8px;
    padding-rightt: 8px;
    gap: 8px;
`
export const TotalContainer = styled(HorizontalFlexDiv)`
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
`